import { ReactComponent as IconWeChat } from 'assets/integrationIcon/ic-wechat-color.svg'
import { ReactComponent as IconWeChatMiniApp } from 'assets/integrationIcon/ic-wechatminiapp-color.svg'
import { ReactComponent as IconLine } from 'assets/integrationIcon/ic-line-color.svg'
import { ReactComponent as IconWhatsApp } from 'assets/integrationIcon/ic-whatsapp-color.svg'
import { ReactComponent as IconWhatsAppBusiness } from 'assets/integrationIcon/ic-whatsapp-business-color.svg'
import { ReactComponent as IconWhatsAppPassive } from 'assets/integrationIcon/ic-whatsapp-passive-color.svg'
import { ReactComponent as IconWhatsAppPassiveGray } from 'assets/integrationIcon/ic-whatsapp-passive-gray.svg'
import { ReactComponent as IconSignal } from 'assets/integrationIcon/ic-signal-color.svg'
import { ReactComponent as IconSMS } from 'assets/integrationIcon/ic-sms-color.svg'
import { ReactComponent as IconLeap } from 'assets/integrationIcon/ic-leap-color.svg'
import { ReactComponent as IconWeComPassive } from 'assets/integrationIcon/ic-wecom-passive-color.svg'
import { ReactComponent as IconWeChatWeCom } from 'assets/integrationIcon/ic-wechat-wecom-color.svg'
import { ReactComponent as IconTelegramNative } from 'assets/integrationIcon/ic-telegram_native-color.svg'
import { ReactComponent as IconTelegramNativeGray } from 'assets/integrationIcon/ic-telegram-native-gray.svg'
import { ReactComponent as IconTeams } from 'assets/integrationIcon/ic-teams-color.svg'
import { ReactComponent as IconSMSPassive } from 'assets/integrationIcon/ic-sms-passive-color.svg'
import { ReactComponent as IconIMessagePassive } from 'assets/integrationIcon/ic-imessage-passive-color.svg'
import { ReactComponent as IconIMessage } from 'assets/integrationIcon/ic-imessage-governed.svg'
import { ReactComponent as IconIosSms } from 'assets/integrationIcon/ic-ios-sms.svg'
import { ReactComponent as IconVoIP } from 'assets/integrationIcon/ic-voip-color.svg'
import { ReactComponent as IconVoIPGray } from 'assets/integrationIcon/ic-voip-gray.svg'
import { ReactComponent as IconVoIPNative } from 'assets/integrationIcon/ic-voipnative-color.svg'
import { ReactComponent as IconVoIPNativeGray } from 'assets/integrationIcon/ic-voipnative-gray.svg'

import { ReactComponent as IconWeChatGray } from 'assets/integrationIcon/ic-wechat-gray.svg'
import { ReactComponent as IconWeChatMiniAppGray } from 'assets/integrationIcon/ic-wechatminiapp-gray.svg'
import { ReactComponent as IconLineGray } from 'assets/integrationIcon/ic-line-gray.svg'
import { ReactComponent as IconWhatsAppGray } from 'assets/integrationIcon/ic-whatsapp-gray.svg'
import { ReactComponent as IconWhatsAppBusinessGray } from 'assets/integrationIcon/ic-whatsapp-business-gray.svg'
import { ReactComponent as IconWeComPassiveGray } from 'assets/integrationIcon/ic-wecom-passive-gray.svg'
import { ReactComponent as IconWeChatWeComGray } from 'assets/integrationIcon/ic-wechat-wecom-gray.svg'
import { ReactComponent as IconIMessageGray } from 'assets/integrationIcon/ic-imessage-governed-gray.svg'
import { ReactComponent as IconNetworkSMSColor } from 'assets/integrationIcon/ic-networksms-color.svg'
import { ReactComponent as IconNetworkSMSGray } from 'assets/integrationIcon/ic-networksms-gray.svg'
import { ReactComponent as IconSignalNativeColor } from 'assets/integrationIcon/ic-signal-native-color.svg'
import { ReactComponent as IconSignalNativeGray } from 'assets/integrationIcon/ic-signal-native-gray.svg'

import { ReactComponent as IconSlack } from 'assets/integrationIcon/ic-slack.svg'

export const CLIENT_ACTIONS_VALUES = {
  ASSIGN_TO_ORGANIZATIONAL_UNIT: 'ASSIGN_TO_OGRANIZATIONAL_UNIT',
  ASSIGN_TO_USER: 'ASSIGN_TO_USER',
  ARCHIVED: 'ARCHIVED',
  EXPORT_CLIENT_MODAL: 'EXPORT_CLIENT_MODAL',
  UNARCHIVED: 'UNARCHIVED',
  VIEW_DETAILS: 'VIEW_DETAILS',
}

export enum ACTIONS_TYPE {
  VIEW_DETAILS = 'VIEW_DETAILS',
  CHANGE_ORG_UNIT = 'CHANGE_ORG_UNIT',
  EXPORT = 'EXPORT',
  MANAGER_ROLE = 'MANAGER_ROLE',
  MANAGE_DELEGATIONS = 'MANAGE_DELEGATIONS',
  ARCHIVED = 'ARCHIVED',
  UNARCHIVED = 'UNARCHIVED',
  ADD_NEW_AM = 'ADD_NEW_AM',
}

const CHANNELS_NOT_SHOWN_AS_DLP_OPTIONS = ['whatsappnative', 'whatsappbusiness']

export default {
  TOKEN: 'token',
  KEYCLOCK_INIT_INFO: 'KEYCLOCK_INIT_INFO',
  DIGEST: 'digest',
  COMPANY_ID: 'companyId',
  REDIRECT_PATH: 'redirect',

  RETRY_UNEXPECTED: 'retryUnexpected',
  SHOW_MESSAGE_ERROR_TO_LOGIN: 'SHOW_MESSAGE_ERROR_TO_LOGIN',
  IS_USE_REACT_SCAN: 'IS_USE_REACT_SCAN',
  SHOW_SIGNALS_ONBOARDING: 'SHOW_SIGNALS_ONBOARDING',

  getClientActions: ({
    hasAssignToUser,
    hasArchive,
    archiveOnly,
  }: {
    hasAssignToUser?: boolean
    hasArchive?: boolean
    archiveOnly?: boolean
  }) => {
    const archive = {
      value: CLIENT_ACTIONS_VALUES.ARCHIVED,
      label: 'Archive',
      group: 3,
    }

    if (archiveOnly) {
      return [archive]
    }

    const clientActions = [
      {
        value: CLIENT_ACTIONS_VALUES.ASSIGN_TO_ORGANIZATIONAL_UNIT,
        label: 'Assign to Organizational Unit',
        group: 2,
      },
    ]

    if (hasAssignToUser) {
      clientActions.push({
        value: CLIENT_ACTIONS_VALUES.ASSIGN_TO_USER,
        label: 'Assign to User',
        group: 2,
      })
    }

    if (hasArchive) {
      clientActions.push(archive)
    }

    return clientActions
  },
  TERM_OF_USE: [
    {
      value: 'PUBLISH',
      label: 'Publish',
    },
  ],
}

export enum EChannel {
  Leap = 'leap',
  WhatsApp = 'whatsapp',
  WechatMiniApp = 'wechatminiapp',
  Wechat = 'wechat',
  Line = 'line',
  Sms = 'sms',
  Signal = 'signal',
  Teams = 'teams',
  TelegramNative = 'telegrampassive',
  Wecom = 'wecompassive',
  WechatWecom = 'wechatwecom',
  WhatsAppNative = 'whatsapparchived',
  WhatsAppBusiness = 'whatsappbusiness',
  Imessage = 'imessage',
  ImessageNative = 'imessagearchived',
  SmsNative = 'smsarchived',
  SmsTango = 'sms2b',
  Slack = 'slack',
}

export const INTEGRATED_CHANNELS: { [key in string]: string } = {
  //this whatsappnative is only used in companyProfile and Report
  //seems like a deprecated channel name
  //but because this object is the global-integrated-channels
  //we still keep it here, in case checking one's channel from companyProfile
  //MUST filter out whatsappnative when parsed into Options
  whatsappnative: 'WhatsApp',
  whatsapparchived: 'WhatsApp Native',
  whatsapp: 'WhatsApp',
  whatsappbusiness: 'WhatsApp Business Native',
  wechat: 'WeChat',
  wechatminiapp: 'WeChat MiniApp',
  line: 'LINE',
  sms: 'SMS',
  signal: 'Signal',
  wecompassive: 'WeCom',
  wechatwecom: 'WeChat via WeCom',
  teams: 'Teams',
  telegrampassive: 'Telegram Native',
  imessagearchived: 'iMessage Native',
  smsarchived: 'SMS Native',
  imessage: 'iMessage',
  networksms: 'Network-based SMS',
  signalarchived: 'Signal Native',
}

const PASSIVE_CHANNELS: { [key in string]: string } = {
  teams: 'Microsoft Teams',
  slack: 'Slack',
  // add more passive channels here
}

const EX_CHANNELS: { [key in string]: string } = {
  voice: 'VoIP Governed',
  voicenative: 'VoIP Native',
  slack: 'Slack',
}

export const ALL_CHANNELS: { [key in string]: string } = {
  ...INTEGRATED_CHANNELS,
  leap:
    (process.env.REACT_APP_CUSTOMIZE_COMPANY_LEAP_CHANNEL_NAME as string) ||
    'Leap',
}

const ALL_CHANNELS_WITH_EX_CHANNELS: { [key in string]: string } = {
  ...ALL_CHANNELS,
  ...EX_CHANNELS,
}

export const ALL_CHANNEL_LABELS = {
  ...ALL_CHANNELS_WITH_EX_CHANNELS,
  ...PASSIVE_CHANNELS,
}

type ColorType = 'colored' | 'gray'
type TOptions = {
  isIosIMessageForImessageArchived?: boolean //for imessagearchived, check if `iMessage iOS iMessage & SMS channel` or not
}
export const getIconByChannel = (
  channelId: string,
  colorType: ColorType,
  options?: TOptions,
) => {
  let xhtml = null
  const isGray = colorType === 'gray'

  switch (channelId) {
    case 'wechat':
      xhtml = isGray ? IconWeChatGray : IconWeChat
      break
    case 'wecompassive':
      xhtml = isGray ? IconWeComPassiveGray : IconWeComPassive
      break
    case 'telegrampassive':
      xhtml = isGray ? IconTelegramNativeGray : IconTelegramNative
      break
    case 'wechatwecom':
      xhtml = isGray ? IconWeChatWeComGray : IconWeChatWeCom
      break
    case 'wechatminiapp':
      xhtml = isGray ? IconWeChatMiniAppGray : IconWeChatMiniApp
      break
    case 'whatsapp':
      xhtml = isGray ? IconWhatsAppGray : IconWhatsApp
      break
    case 'whatsappnative':
      xhtml = IconWhatsApp
      break
    case 'whatsapparchived':
      xhtml = isGray ? IconWhatsAppPassiveGray : IconWhatsAppPassive
      break
    case 'whatsappbusiness':
      xhtml = isGray ? IconWhatsAppBusinessGray : IconWhatsAppBusiness
      break
    case 'line':
      xhtml = isGray ? IconLineGray : IconLine
      break
    case 'sms':
      xhtml = IconSMS
      break
    case 'smsarchived':
      xhtml = IconSMSPassive
      break
    case 'networksms':
      xhtml = isGray ? IconNetworkSMSGray : IconNetworkSMSColor
      break
    case 'imessagearchived':
      xhtml = options?.isIosIMessageForImessageArchived
        ? IconIosSms
        : IconIMessagePassive
      break
    case 'signal':
      xhtml = IconSignal
      break
    case 'signalarchived':
      xhtml = isGray ? IconSignalNativeGray : IconSignalNativeColor
      break
    case 'leap':
      xhtml = IconLeap
      break
    case 'teams':
      xhtml = IconTeams
      break
    case 'imessage':
      xhtml = isGray ? IconIMessageGray : IconIMessage
      break
    case 'voice':
      xhtml = isGray ? IconVoIPGray : IconVoIP
      break
    case 'voicenative':
      xhtml = isGray ? IconVoIPNativeGray : IconVoIPNative
      break
    case 'slack':
      xhtml = isGray ? IconSlack : IconSlack
  }

  return xhtml
}

const generateIconMappingsForChannels = (
  channels: Record<string, string>,
  colorType: ColorType,
) => {
  let result = {}

  Object.keys(channels).forEach((channelId) => {
    result = {
      ...result,
      [channelId]: {
        displayName: channels[channelId],
        icon: getIconByChannel(channelId, colorType),
      },
    }
  })

  return result
}

const generateIconMappingsForDLPChannels = (
  channels: Record<string, string>,
  colorType: ColorType,
) => {
  let result = {}

  Object.keys(channels).forEach((channelId) => {
    if (!CHANNELS_NOT_SHOWN_AS_DLP_OPTIONS.includes(channelId)) {
      result = {
        ...result,
        [channelId]: {
          displayName: channels[channelId],
          icon: getIconByChannel(channelId, colorType),
        },
      }
    }
  })

  return result
}

type TIconsMapping = {
  displayName: string
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

export const channelsIconsMappingForIntegratedChannels: {
  [key in string]: TIconsMapping
} = generateIconMappingsForChannels(INTEGRATED_CHANNELS, 'colored')

export const channelsIconsMappingForAllChannels: {
  [key in string]: TIconsMapping
} = generateIconMappingsForChannels(ALL_CHANNELS_WITH_EX_CHANNELS, 'colored')

export const grayChannelsIconsMappingForIntegratedChannels: {
  [key in string]: TIconsMapping
} = generateIconMappingsForChannels(INTEGRATED_CHANNELS, 'gray')

export const grayChannelsIconsMappingForAllChannels: {
  [key in string]: TIconsMapping
} = generateIconMappingsForChannels(ALL_CHANNELS_WITH_EX_CHANNELS, 'gray')

export const channelsIconsMappingForDLP: {
  [key in string]: TIconsMapping
} = generateIconMappingsForDLPChannels(ALL_CHANNELS, 'colored')

type TCompanyProfileHiddenChannels = {
  hiddenWechatChannel?: boolean
  hiddenLineChannel?: boolean
  hiddenWhatsappChannel?: boolean
  hiddenWechatminiappChannel?: boolean
  hiddenSmsChannel?: boolean
  hiddenSignalChannel?: boolean
  hiddenWecomChannel?: boolean
  hiddenTelegramChannel?: boolean
}

export const getAllChannelsIconsMappingFilteredByCompanyProfile = (
  companyProfile: TCompanyProfileHiddenChannels,
) => {
  const result = { ...channelsIconsMappingForDLP }
  const {
    hiddenWechatChannel,
    hiddenLineChannel,
    hiddenWhatsappChannel,
    hiddenWechatminiappChannel,
    hiddenSmsChannel,
    hiddenSignalChannel,
    hiddenWecomChannel,
    hiddenTelegramChannel,
  } = companyProfile || {}

  if (hiddenWechatChannel) {
    delete result['wechat']
  }
  if (hiddenLineChannel) {
    delete result['line']
  }
  if (hiddenWhatsappChannel) {
    delete result['whatsapp']
  }
  if (hiddenWechatminiappChannel) {
    delete result['wechatminiapp']
  }
  if (hiddenSmsChannel) {
    delete result['sms']
  }
  if (hiddenSignalChannel) {
    delete result['signal']
  }
  if (hiddenWecomChannel) {
    delete result['wecompassive']
    delete result['wechatwecom']
  }
  if (hiddenTelegramChannel) {
    delete result['telegrampassive']
  }
  //NOTE: For now, LEAP is kind of a special channel
  //and do not have related config attribute
  //so we always turn on this channel
  //when getting all channels of the system
  //regardless of companyProfile config

  return result
}

export const getIntegratedChannelsIconsMappingFilteredByCompanyProfile = (
  companyProfile: TCompanyProfileHiddenChannels,
) => {
  const result = { ...channelsIconsMappingForIntegratedChannels }
  const {
    hiddenWechatChannel,
    hiddenLineChannel,
    hiddenWhatsappChannel,
    hiddenWechatminiappChannel,
    hiddenSmsChannel,
    hiddenSignalChannel,
    hiddenWecomChannel,
    hiddenTelegramChannel,
  } = companyProfile || {}

  if (hiddenWechatChannel) {
    delete result['wechat']
  }
  if (hiddenLineChannel) {
    delete result['line']
  }
  if (hiddenWhatsappChannel) {
    delete result['whatsapp']
  }
  if (hiddenWechatminiappChannel) {
    delete result['wechatminiapp']
  }
  if (hiddenSmsChannel) {
    delete result['sms']
  }
  if (hiddenSignalChannel) {
    delete result['signal']
  }
  if (hiddenWecomChannel) {
    delete result['wecompassive']
    delete result['wechatwecom']
  }
  if (hiddenTelegramChannel) {
    delete result['telegrampassive']
  }

  return result
}

export const integratedChannelOptions = Object.keys(
  channelsIconsMappingForIntegratedChannels,
).map((channelKey: string) => {
  return {
    ...channelsIconsMappingForIntegratedChannels[channelKey],
    value: channelKey,
  }
})

export const fileType = {
  STD_TEXT: 'Standard text',
  HYPERLINK: 'Hyperlinks',
  ATTACHMENT_OFFICE: 'Office attachments',
  ATTACHMENT_OTHER: 'Other attachments',
}

export const FILE_TYPE_COLOR_MAPPING = {
  STD_TEXT: '#E54C66',
  ATTACHMENT_OTHER: '#f1b03a',
  ATTACHMENT_OFFICE: '#456EFF',
  HYPERLINK: '#795CD2',
}
export const ChatTypeConst = {
  DIRECT: 'Direct chats',
  GROUP: 'Group chats',
}

export const TYPE_ROLES = {
  ADMINISTRATIVE: 'Administrative Role',
  FUNCTIONAL: 'Functional Role',
  USER_CLIENT: 'User_Client Role',
}

export const attrTypeConst = {
  external: 'External (SAML)',
  internal: 'Internal Profile',
}

export const operatorConst = { IS: 'is', IS_NOT: 'is not' }

export const AttributeNameConst = {
  COUNTRY: 'Country',
  ORGANIZATIONAL_UNIT_ID: 'Organizational Unit',
  LANGUAGE: 'Language',
  TIMEZONE: 'Timezone',
  EXTERNAL_COMPANY_ID: 'External Company',
  STATUS: 'Status',
  JOB_TITLE: 'Job Title',
  FEDERATED_IDENTITY_ATTRIBUTE: '',
}

export const AttributeNameJsonPathConst = {
  '$.persona.country': 'Country',
  '$.organizationalUnitId': 'Organizational Unit',
  '$.persona.language': 'Language',
  '$.persona.timezone': 'Timezone',
  '$.externalCompanyIds': 'External Company',
  '$.status': 'Status',
  '$.persona.jobTitle': 'Job Title',
}

export const BOT_TYPE = {
  UNKNOWN: 'UNKNOWN',
  API_KEY: 'API_KEY',
  INBOUND: 'INBOUND',
  WORKFLOW: 'WORKFLOW',
  MENTIONED: 'MENTIONED',
}

export const MAX_FILE_SIZE = 2 * 1024 * 1024
export const MAX_FILE_SIZE_5MB = 5 * 1024 * 1024

export const STATUS_ONBOARDING = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  SKIP: 'SKIP',
}

export const GUIDE_TYPES = {
  HOME_GET_STARTED: 'HOME_GET_STARTED',
  HOME_WHATS_NEW: 'HOME_WHATS_NEW',
  HOME_FAQS: 'HOME_FAQS',
  HOME_LIVE_CHAT: 'HOME_LIVE_CHAT',
  HOME_SEARCH_BAR: 'HOME_SEARCH_BAR',
  HOME_QUICK_START: 'HOME_QUICK_START',

  MANAGE_CHANNELS_INTEGRATION: 'MANAGE_CHANNELS_INTEGRATION',
  LINK_ACCOUNT: 'LINK_ACCOUNT',
  LINK_ACCOUNT_V2: 'LINK_ACCOUNT_V2',
  LIST_ALL_CHANNEL_GUIDE: 'LIST_ALL_CHANNEL_GUIDE',
  ACCOUNT_SUCCESS_LINK_STEP2: 'ACCOUNT_SUCCESS_LINK_STEP2',
  ACCOUNT_SUCCESS_LINK_STEP3: 'ACCOUNT_SUCCESS_LINK_STEP3',
  ACCOUNT_WAITING_LINK: 'ACCOUNT_WAITING_LINK',
  ADD_TEAM_NUMBER_MANUAL: 'ADD_TEAM_NUMBER_MANUAL',
  ADD_TEAM_MEMBER_MANUAL_SUCCESS: 'ADD_TEAM_MEMBER_MANUAL_SUCCESS',
  ENABLE_ARCHIVING_PHONE_NUMBER: 'ENABLE_ARCHIVING_PHONE_NUMBER',
  QUICK_START: 'QUICK_START',

  IOS_SMS_GUIDE: 'IOS_SMS_GUIDE',
  IOS_SMS_GUIDE_SUCCESS: 'IOS_SMS_GUIDE_SUCCESS',
  IOS_SMS_GUIDE_ERROR: 'IOS_SMS_GUIDE_ERROR',
  ANDROID_SMS_GUIDE: 'ANDROID_SMS_GUIDE',
  ANDROID_SMS_GUIDE_SUCCESS: 'ANDROID_SMS_GUIDE_SUCCESS',
  ANDROID_SMS_GUIDE_ERROR: 'ANDROID_SMS_GUIDE_ERROR',
  IOS_ANDROID_SMS_GUIDE: 'IOS_ANDROID_SMS_GUIDE', //it highlight 2 channel (ios and android)
  IOS_ANDROID_SMS_GUIDE_ERROR: 'IOS_ANDROID_SMS_GUIDE_ERROR', //it highlight 2 channel (ios and android)
  WHATSAPP_GUIDE: 'WHATSAPP_GUIDE',
  WHATSAPP_GUIDE_SUCCESS: 'WHATSAPP_GUIDE_SUCCESS',
  WHATSAPP_GUIDE_ERROR: 'WHATSAPP_GUIDE_ERROR',
  ANOTHER_GUIDE: 'ANOTHER_GUIDE', //channel guide that not implemented

  MAXEN_SIGNALS_TOPICS: 'MAXEN_SIGNALS_TOPICS',
  MAXEN_SIGNALS_TRENDS: 'MAXEN_SIGNALS_TRENDS',
}

export const urlLoadDataRetentionCursor = ['/chat-room']

export const TIME_FORMAT = {
  DATE: 'MM/DD/YYYY',
  MONTH_DAY_YEAR: 'MMM DD, YYYY',
  MONTH_DAY_YEAR_HOUR: 'MMM DD, YYYY, HH:mm',
  DATE_TIME: 'MM/DD/YYYY HH:mm',
  DATE_TIME_FULL: 'DD/MM/YYYY HH:mm:ss',
  TIME_24H: 'HH:mm',
} as const

export const USERNAME_LENGTH = {
  MIN: 3,
  MAX: 60,
}

export const CLIENT_USERNAME_LENGTH = {
  MIN: 3,
  MAX: 32,
}
